import React from 'react'
import { ErrorText, Input, TextArea, Title, WrapperInput } from './styles'
import PropTypes from 'prop-types'

export const TextBox = ({
  title,
  placeholder,
  TextError,
  onChange,
  ErrorValue,
  value,
  disabled,
  idTest = '',
  maxLength
}) => {
  return (
    <>
      <WrapperInput>
        {title && <Title>{title}:</Title>}
        <Input
          title={title}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
          data-testid={idTest}
          maxLength={maxLength}
        />
        {ErrorValue === true && <ErrorText data-testid={idTest + '-error'}>{TextError}</ErrorText>}
      </WrapperInput>
    </>
  )
}

export const TextDescription = ({ title = undefined, placeholder, TextError, onChange, onKeyUp, ErrorValue, value, idTest, maxLength }) => {
  return (
    <>
      <WrapperInput>
        {title && <Title>{title}:</Title>}
        <TextArea data-testid={idTest} placeholder={placeholder} onChange={onChange} value={value} maxLength={maxLength} onKeyUp={onKeyUp}/>
        {ErrorValue === true && <ErrorText data-testid={idTest + '-error'}>{TextError}</ErrorText>}
      </WrapperInput>
    </>
  )
}

TextBox.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  TextError: PropTypes.string,
  onChange: PropTypes.func,
  ErrorValue: PropTypes.bool,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  idTest: PropTypes.string,
  maxLength: PropTypes.number
}

TextDescription.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  TextError: PropTypes.string,
  onChange: PropTypes.func,
  ErrorValue: PropTypes.bool,
  value: PropTypes.any,
  idTest: PropTypes.string,
  maxLength: PropTypes.number,
  onKeyUp: PropTypes.func || undefined
}
